export default __webpack_public_path__ + "static/media/step-three-1.0c59cf2d.svg";